import { motion } from 'framer-motion';

export const WhatsAppButton = () => {
    return (
        <motion.a
            href="https://wa.me/447440747050"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-float-btn"
            className="whatsapp-float"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 1, type: 'spring', stiffness: 200 }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            aria-label="Contact us on WhatsApp"
        >
            <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.958A15.887 15.887 0 0016.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.316 22.612c-.396 1.116-1.958 2.042-3.2 2.312-.852.182-1.966.326-5.714-1.228-4.792-1.988-7.876-6.852-8.116-7.168-.23-.316-1.932-2.572-1.932-4.904 0-2.332 1.222-3.476 1.656-3.952.396-.436 1.056-.638 1.688-.638.192 0 .366.01.52.018.436.018.654.044 .942.728.36.854 1.238 3.018 1.346 3.238.108.22.216.524.068.84-.138.326-.256.472-.476.728-.22.256-.428.452-.648.728-.198.246-.422.508-.18.944.242.436 1.078 1.778 2.316 2.88 1.59 1.416 2.93 1.856 3.346 2.064.318.158.696.128.948-.148.316-.352.708-.936 1.108-1.51.284-.412.644-.462.998-.316.36.138 2.27 1.07 2.66 1.266.39.196.648.294.744.458.098.164.098.95-.298 2.066z"/>
            </svg>
        </motion.a>
    );
};
